// extracted by mini-css-extract-plugin
export default {"calendarContainer":"SmallCalendar_calendarContainer__+5RZA"};